/*
	Copyright (c) 2022 PierceGearhart
    StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (StellaNode).
*/

import { useState } from 'react'
import Primary from '../components/buttons/primary'

type Props = {
    title: string
    tags: Array<string>
    price: string
    link: string
}

const JobCard: React.FC<Props> = ({ title, tags, price, link, children }) => {
    const [isOpen, setIsOpen] = useState(false)

    return (
        <div className="px-8 py-5 bg-primary-light shadow-xl rounded-md border-b-2 border-primary-lighter cursor-pointer" onClick={() => isOpen === false ? setIsOpen(true) : setIsOpen(false)}>
            <div className="header flex items-center">
                <div>
                    <h1 className="text-xl text-gray-100 font-semibold mb-3.5 select-none">{title}</h1>
                </div>
                <div className="arrow ml-auto">
                    <svg xmlns="http://www.w3.org/2000/svg" className="text-gray-200 h-5 w-5 mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                    </svg>
                </div>
            </div>
            <div className="flex flex-wrap items-center">
                {tags.map((tag:any) => (
                    <div className="w-1/2 sm:w-1/2 md:w-auto lg:w-auto pr-3 sm:pr-3 md:pr-0 lg:pr-0 mb-2 sm:mb-2 md:mb-0 lg:mb-0">
                        <span className="bg-primary-lighter px-4 py-0.5 rounded-md mr-0 sm:mr-0 md:mr-3 lg:mr-3 text-gray-300 flex items-center text-sm select-none">
                            <svg xmlns="http://www.w3.org/2000/svg" className="text-purple-500 h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                            </svg>
                            {tag}
                        </span>
                    </div>
                ))}
            </div>
            {isOpen === true &&
                <div className="dropdown mt-6 mb-3">
                    <hr className="border-gray-500 mb-5" />
                    <div className="job-info mb-8">
                        {children}
                    </div>
                    <div className="flex flex-wrap items-center">
                        <div className="w-full sm:w-full md:w-auto lg:w-auto mb-7 sm:mb-7 md:mb-0 lg:mb-0">
                            <p className="text-gray-100 font-semibold underline">Starting at ${price}/month</p>
                        </div>
                        <div className="ml-0 sm:ml-0 md:ml-auto lg:ml-auto">
                            <Primary rounded='sm' arrow={false} length='lg' link={link}>Apply</Primary>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export default JobCard